export const PPC_DATA = Symbol.for('PPC_DATA');

export const LOYALTY_3PC_OFFER_NAMES = {
  multiplier: 'MULTIPLIER',
  pointsPerDollar: 'PULSE',
  powerPoints: 'FIXED',
};

export const LOYALTY_TIER_DETAILS = {
  base: {
    icon: 'loyallist-small',
    membershipDetails: {
      membership: 'Loyallists',
    },
    modalDetails: {
      membership: 'Loyallist',
      pointsPerDollar: 3,
    },
  },
  tol: {
    icon: 'loyallist-small-black',
    membershipDetails: {
      membership: 'Top of the list members',
    },
    modalDetails: {
      membership: 'Top of the List Loyallist',
      pointsPerDollar: 4,
    },
  },
  unl: {
    icon: 'loyallist-key-small',
    membershipDetails: {
      membership: 'Top of the list unlocked members',
    },
    modalDetails: {
      membership: 'Top of the List Unlocked Loyallist',
      pointsPerDollar: 10,
    },
  },
  bronze: {
    icon: 'star-rewards-bronze-large',
    membershipDetails: {},
    modalDetails: {},
  },
  silver: {
    icon: 'star-rewards-silver-large',
    membershipDetails: {},
    modalDetails: {},
  },
  gold: {
    icon: 'star-rewards-gold-large',
    membershipDetails: {},
    modalDetails: {},
  },
  platinum: {
    icon: 'star-rewards-platinum-large',
    membershipDetails: {},
    modalDetails: {},
  },
};

export const LOYALTY_COPIES = [
  {
    type: 'base',
    copy: 'Earn <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span> with purchase.',
    perksCopy: 'Earn [$AWARDED_POINTS] points with purchase.',
    tags: [
      '[$AWARDED_POINTS]',
    ],
    includeDetails: false,
  },
  {
    type: 'multiplier',
    copy: 'Earn [$MULTIPLIER]X points with purchase (that’s <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span>)!',
    perksCopy: 'Earn [$MULTIPLIER]X points with purchase (that’s [$AWARDED_POINTS] points)!',
    tags: [
      '[$MULTIPLIER]',
      '[$AWARDED_POINTS]',
    ],
    includeDetails: true,
  },
  {
    type: 'pointsPerDollar',
    copy: 'Earn an extra [$PULSE] points per dollar with purchase (that’s <span class="loyalty-text--total-points">[$AWARDED_POINTS] points</span>)!',
    perksCopy: 'Earn an extra [$PULSE] points per dollar with purchase (that’s [$AWARDED_POINTS] points)!',
    tags: [
      '[$PULSE]',
      '[$AWARDED_POINTS]',
    ],
    includeDetails: true,
  },
  {
    type: 'powerPoints',
    copy: 'Get Power Points on this item',
    perksCopy: 'Get Power Points on this item',
    tags: [],
  },
];
